<template>
  <PageHeader title="Historique" />

  <Loading v-if="loading" />
  <ChallengeList v-else :challenges="challenges" :storeId="this.selectedStoreId" />
</template>

<script>
import { mapState } from "vuex";
import ChallengesService from "@/api/services/challenges";
import { Loading, PageHeader, toCamelCase } from "@estaly/ui";
import ChallengeList from "@/components/challenge/ChallengeList.vue";

export default {
  components: { ChallengeList, Loading, PageHeader },

  data() {
    return {
      loading: true,
      challenges: [],
    };
  },

  computed: {
    ...mapState("store", ["selectedStoreId"]),
  },

  async mounted() {
    if (this.selectedStoreId) {
      await this.retrieveChallenges();
    }
  },

  methods: {
    async retrieveChallenges() {
      this.loading = true;
      const response = await ChallengesService.fetchIndex(this.selectedStoreId, { perPage: 2000 });
      if (response?.success) {
        const data = toCamelCase(response.data);
        this.challenges = data.challenges;
      }
      this.loading = false;
    },
  },
};
</script>
